import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {
  Router, Event, NavigationStart, ActivatedRoute
} from '@angular/router';
import {AuthService} from '../core/auth.service';
import {UserService} from '../services/user.service';
import {AchooPopupComponent} from '../core/achoo-popup/achoo-popup.component';
import {ModalService} from '../services/modal/modal.service';
import {Subscription} from 'rxjs/Subscription';
import {FormBuilder, FormGroup} from '@angular/forms';
import {AppSettings} from '../utils/app-settings';
import {FeaturePermission} from '../../models/influencer/feature-permission';
import { InfluencerService } from '../services/influencer/influencer.service';

@Component({
  selector: 'app-influencer-main',
  templateUrl: './influencer-main.component.html',
  styleUrls: ['./influencer-main.component.scss']
})

export class InfluencerMainComponent implements OnInit, OnDestroy {
  @ViewChild('TermsAndConditionAccept') termsAndConditionAccept: AchooPopupComponent;
  @ViewChild('InfluencerConfirmation') influencerConfirmation: AchooPopupComponent;
  public newUser: FormGroup;
  public showFadedBg: boolean;
  public termsAndConditionSubscription: Subscription;
  public isAcceptionTermAndCon = false;
  public expandMobileMenu = false;
  public isNewCampaign = false;

  private featurePermissionSubscription: Subscription;
  private featurePermission = new FeaturePermission(false, false);

  constructor(private auth: AuthService,
              private router: Router,
              private formBuilder: FormBuilder,
              private modalService: ModalService,
              private userService: UserService,
              private activatedRoute: ActivatedRoute,
              private influencerService: InfluencerService) {}

  ngOnInit() {
    this.initializeInfluencerConfirmationModal();
    // Make mobile close menu when route
    this.router
    .events
    .subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.expandMobileMenu = false;
      }
    });

    this.featurePermissionSubscription = this.auth.influencerFeaturePermission.subscribe((permission) => {
      if (permission) {
        this.featurePermission = permission;
      }
    });

    this.activatedRoute.queryParams.subscribe(params => {
      this.isNewCampaign = params.isNewCampaign;
    });
  }

  private initializeInfluencerConfirmationModal() {
    this.termsAndConditionSubscription = this.auth.termsAndConditionObserver.subscribe((res) => {
      if (res) {
        this.modalService.close();
      } else if (AppSettings.isActiveNewCampaignFlow()) {
        this.modalService.openInCenter(this.influencerConfirmation, this.beforeDismissConfirmationPopup.bind(this), 'infl-confirm-modal', true);
      } else {
        this.modalService.openInCenter(this.termsAndConditionAccept, this.beforeDismissAcceptionTerm.bind(this), 'term-accept-modal', true);
      }
    });
    this.newUser = this.formBuilder.group({
      acceptTermService: [ null ]
    });
    const currentInfluencer = this.userService.getInfluencerInfo();
    if (!this.auth.isAccessingLandingPage(this.router.url) && currentInfluencer && !currentInfluencer.acceptedTermService) {
      this.auth.needAcceptedTermAndCondition();
    }
  }

  ngOnDestroy() {
    if (this.termsAndConditionSubscription) {
      this.termsAndConditionSubscription.unsubscribe();
    }
    if (this.featurePermissionSubscription) {
      this.featurePermissionSubscription.unsubscribe();
    }
  }

  toggleMobileMenu() {
    this.expandMobileMenu = !this.expandMobileMenu;
  }

  public popperOnShown(e) {
    this.showFadedBg = true;
  }

  public popperOnHidden(e) {
    this.showFadedBg = false;
  }

  beforeDismissAcceptionTerm() {
    setTimeout(() => {
      this.modalService.openInCenter(this.termsAndConditionAccept, this.beforeDismissAcceptionTerm.bind(this), 'term-accept-modal');
    }, 200);
  }

  beforeDismissConfirmationPopup() {
    setTimeout(() => {
      this.modalService.openInCenter(this.influencerConfirmation, this.beforeDismissConfirmationPopup.bind(this), 'infl-confirm-modal');
    }, 200);
  }

  public logout() {

    this.auth.logout();
    this.userService.addInfluencerInfo(null);
    this.router.navigate([`/influencer/login`]);

    return false;
  }

  public acceptTermAndCondition({ value, valid }: {value: any, valid: boolean}) {
    const isAcceptTermService = value.acceptTermService;
    if (isAcceptTermService) {
      const user = this.auth.getUser();
      this.userService.acceptionTermAndCondition(user.data.id, 'user').subscribe((res) => {
        this.userService.updateAcceptTermAndService(true);
        this.auth.haveAcceptedTermAndCondition();
        this.auth.updateUser('user');
        this.termsAndConditionSubscription.unsubscribe();
      });
    }
  }

  public onAcceptTheConfirmation() {
    this.modalService.close();
    this.userService.updateAcceptTermAndService(true);
    this.auth.haveAcceptedTermAndCondition();
    this.influencerService.confirmingInfluencerNameAndEmail();
    this.termsAndConditionSubscription.unsubscribe();
  }

  public onConfirmInfluencerInfoError() {
    this.initializeInfluencerConfirmationModal();
    this.influencerService.confirmedInfluencerNameAndEmail();
    this.modalService.openInCenter(this.influencerConfirmation, null, 'infl-confirm-modal', true);
  }

  get logoImage() {
    return this.userService.logoImage;
  }

  get isDisableHomePage() {
    return AppSettings.isDisableHomepage();
  }

  get isDisableInboxPage() {
    return !this.featurePermission.enableCommunication;
  }

  get isDisableCampaignPage() {
    return !this.featurePermission.enableCampaign;
  }

  get userAvatarImage() {
    const currentuser = this.userService.getInfluencerInfo();
    if (currentuser && currentuser.profilePicture) {
      return currentuser.profilePicture;
    } else {
      return 'assets/images/sidebar/default-user-avatar.png';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/influencer-main/influencer-main.component.ts